// extracted by mini-css-extract-plugin
export default {"titleBlock":"styles_titleBlock__XwuzR","title":"styles_title__Kb8Tw","arrow":"styles_arrow__Obf0S","dropDownBlock":"styles_dropDownBlock__47FrC"};